<template>
  <div v-for="(input, index) in inputs" :key="index" class="mb-3">
    <input
        type="text"
        class="form-control"
        :id="id + '-' + index"
        v-model="input.value"
        @input="handleInput(index)"
    />
  </div>
</template>

<script setup>
import {defineEmits, defineProps, ref} from "vue";

const props = defineProps({
  id: String,
  modelValue: Array
})

const defaultInputs = props.modelValue?.map(item => ({ value: item }))
const inputs = ref(defaultInputs ?? [{value: ''}]);
inputs.value.push({ value: '' }); // Добавляем новое поле

const handleInput = (index) => {
  if (inputs.value[index].value !== '' && index === inputs.value.length - 1) {
    inputs.value.push({ value: '' }); // Добавляем новое поле, если последнее заполнено
  } else if (inputs.value[index].value === '' && index !== inputs.value.length - 1) {
    inputs.value.splice(index, 1); // Удаляем поле, если оно стало пустым
  }
  collectValues()
};

const emit = defineEmits(['update:modelValue']);
const collectValues = () => {
  emit('update:modelValue', inputs.value
      .map(input => input.value.trim())
      .filter(value => value !== ''));
};


</script>
